export enum CheckoutPageRoutesEnum {
    USER_INFO_PAGE = "/checkout",
    STATE_SELECT_PAGE = "/checkout/select-state",
    PRODUCT_FAMILY_SELECT_PAGE = "/checkout/select-age-group",
    GRADE_CURRICULUM_PAGE = "/checkout/grade-curriculum",
    PLAN_SELECT_PAGE = "/checkout/select-membership",
    CHARGE_SELECT_PAGE = "/checkout/select-pathway",
    ADDON_SELECT_PAGE = "/checkout/select-premium-services",
    INTERNATIONAL_ADDON_PAGE = "/checkout/international-premium-services",
    PAYMENT_PAGE = "/checkout/payment",
    PAYMENT_SUCCESS_PAGE = "/checkout/payment-success",
    EXISTING_USER_PAGE = "/checkout/existing-user",
    STUDENT_SELECTION_PAGE = "/checkout/select-student",
    CREATE_NEW_STUDENT_PAGE = "/checkout/create-new-student"
}
